import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './StaticPage.css';

const Terms = () => {
  const { t } = useLanguage();
  const paragraphs = t('static.termsParagraphs');

  return (
    <div className="static-page">
      <section className="static-page-hero">
        <h1>{t('static.termsTitle')}</h1>
      </section>
      <section className="static-page-body">
        <div className="container static-page-prose">
          {Array.isArray(paragraphs)
            ? paragraphs.map((paragraph) => <p key={paragraph.slice(0, 48)}>{paragraph}</p>)
            : null}
        </div>
      </section>
    </div>
  );
};

export default Terms;
